<template>
  <div class="experimentCard">
    <div class="experimentCard-img">
      <img :src="detail.cover" alt="" />
      <span v-if="detail.obligatory == 1">必修</span>
    </div>
    <div class="container">
      <div class="experimentCard-title">
        <span>{{ getLevel(detail.level) }}</span>
        <p :title="detail.name">{{ detail.name }}</p>
      </div>
      <h4 :title="detail.schoolName">{{ detail.schoolName }}</h4>
      <div class="experimentCard-btn">
        <div class="logo-list">
          <div class="list">
            <img src="@/assets/images/common/eye.png" alt="" /><span>{{
              detail.scanNum
            }}</span>
          </div>
          <div class="line"></div>
          <div class="list">
            <img src="@/assets/images/common/participate.png" alt="" /><span>{{
              detail.upNum
            }}</span>
          </div>
          <div class="line"></div>
          <div class="list">
            <img
              src="@/assets/images/common/collection.png"
              alt=""
              v-if="detail.isFavor == 0"
            />
            <img
              src="@/assets/images/common/collection-active.png"
              v-if="detail.isFavor == 1"
              alt=""
            /><span>{{ detail.favoriteNum }}</span>
          </div>
        </div>
        <div class="btn" @click="goDetail">进入实验</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VirtualimitationExperimentcard",
  props: {
    detail: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {};
  },

  mounted() {},

  methods: {
    goDetail() {
      this.$router.push(`/experimentListDetail?id=${this.detail.id}`);
    },
    getLevel(level) {
      if (level == 4) return "其他";
      if (level == 1) return "国家";
      if (level == 2) return "省级";
      if (level == 3) return "市级";
    },
  },
};
</script>

<style lang="less" scoped>
.experimentCard {
  width: 383px;
  height: 356px;
  background: #fff;
  box-sizing: border-box;
  border-radius: 4px;
  box-shadow: 0px 2px 8px rgba(23, 26, 95, 0.15);
  .experimentCard-img {
    width: 383px;
    height: 230px;
    position: relative;
    span {
      display: block;
      position: absolute;
      top: 13px;
      right: 13px;
      width: 44px;
      height: 22px;
      background: linear-gradient(235deg, #f48867 0%, #ff6554 100%);
      border-radius: 50px;
      font-size: 12px;
      font-family: PingFang-SC;
      font-weight: 500;
      line-height: 17px;
      color: #ffffff;
      line-height: 22px;
      text-align: center;
    }
    img {
      width: 383px;
      height: 230px;
    }
  }
  .container {
    padding: 17px 16px;
    .experimentCard-title {
      display: flex;
      justify-content: start;
      align-items: center;
      span {
        display: inline-block;
        width: 42px;
        height: 17px;
        border: 1px solid #ff6454;
        border-radius: 2px;
        font-size: 12px;
        font-family: PingFang-SC;
        font-weight: 400;
        line-height: 15px;
        color: #ff6554;
        margin-right: 6px;
        text-align: center;
      }
      p {
        width: 300px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        font-size: 16px;
        font-family: PingFang-SC;
        font-weight: 500;
        line-height: 22px;
        color: #424346;
        opacity: 1;
      }
    }
    h4 {
      font-size: 14px;
      font-family: PingFang-SC;
      font-weight: 400;
      line-height: 20px;
      color: #8e8e90;
      opacity: 1;
      margin: 10px 0 9px 0;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    .experimentCard-btn {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .btn {
        width: 96px;
        height: 34px;
        background: #1880fa;
        border-radius: 4px;
        font-size: 14px;
        font-family: PingFang-SC;
        font-weight: 400;
        line-height: 20px;
        color: #ffffff;
        text-align: center;
        line-height: 34px;
        cursor: pointer;
      }
    }
  }
}
.logo-list {
  display: flex;
  justify-content: start;
  //   margin: 24px 0 43px 0;
  .list {
    span {
      font-size: 13px;
      font-family: PingFang-SC;
      font-weight: 400;
      line-height: 18px;
      color: #747f8f;
      opacity: 1;
      margin-left: 5px;
    }
  }
  .line {
    width: 0px;
    height: 16px;
    border: 1px solid #dfe3eb;
    opacity: 1;
    margin: 0 18px;
  }
}
</style>